<div class="card-content">
  <img [src]="getDashboardImage()" [alt]="dashboard.name" class="card-image" />
</div>
<div class="footer">
  <button nz-button class="close-btn" nzSize="large" (click)="close()">Cancel</button>
</div>
